import Default from 'components/layouts/Guest/Default';
import SignIn from 'components/templates/SignIn/SignIn';
import { getUser } from 'utils/service';

const Login = () => {
  const user = getUser();
  return (
  <Default>
    <SignIn />
  </Default>
)};

export default Login;
